import Axios from './axios';

import {
  PAN_ADVANCE,
  PIN_ADVANCE,
  BORROWERS_URL,
  SEND_OTP_URL,
  AUTH_USER_URL,
  GET_DOCUMENT_URL,
  UPLOAD_DOCUMENT_URL,
  CREDIT_AVAIL_URL,
  SET_OFFER_URL,
  ESIGN_INIT_URL,
  GET_BOROWWER_URL,
  GET_ACT_LIST_URL,
  GET_IFSC_URL,
  ESIGN_LIST_URL,
  PENNY_DROP_URL,
  CREATE_BANK_URL,
  GET_BANK_URL,
  GET_INIT_EMANDATE_URL,
  GET_EMANDATE_PHY_NACH_URL,
  GET_ESIGN_DOCUMENT_URL,
  GET_PHONE_LIST_URL,
  GET_ESIGN_DATA_URL
} from './urls';
import { store } from '../../configureStore';


const getAPIKEY = () => {
  return store.getState().app.apiKey;
}

const BORROWERS = async (data) => {
  
  const response = await Axios({
    url: BORROWERS_URL,
    method: 'POST',
    headers: {
      'api-key': getAPIKEY(),
    },
    data: data
  });
  return response.data;
};

const BORROWERSUPDATE = async (data,borrowerResponse) => {
  
  const response = await Axios({
    url: BORROWERS_URL+"/"+borrowerResponse.id,
    method: 'PUT',
    headers: {
      'api-key': getAPIKEY(),
      'Authorization': store.getState().app.authToken.token
    },
    data: data
  });
  return response.data;
};

const getPAN = async (pan) => {
  
  const response = await Axios({
    url: PAN_ADVANCE+"?pan_number="+pan,
    method: 'GET',
    headers: {
      'api-key': getAPIKEY(),
    },
  });
  return response.data;
};

const getPIN = async (pin) => {
  
  const response = await Axios({
    url: PIN_ADVANCE+"?pin_code="+pin,
    method: 'GET',
    headers: {
      'api-key': getAPIKEY(),
    },
  });
  return response.data;
};

const sendOTPAPI = async (data) => {
  
  const response = await Axios({
    url: SEND_OTP_URL,
    method: 'POST',
    headers: {
      'api-key': getAPIKEY(),
    },
    data:{
      "communication": {
              "recipient": data.contact_value,
              "otp_type": "auth",
              "channel": "Mobile",
              "client_reference_id": data.client_reference_id
          }
      }
  });
  return response.data;
};

const authUserAPI = async (otp,otpResponse,borrowerResponse) => {
  
  const response = await Axios({
    url: AUTH_USER_URL,
    method: 'POST',
    headers: {
      'api-key': getAPIKEY(),
    },
    data:{
        "user": {
            "pan_number": borrowerResponse.pan_number,
            "recipient": otpResponse.recipient,
            "otp_reference_id": otpResponse.otp_reference_id,
            "otp": otp
        }
    }
  });
  return response.data;
};

const getBorrowerAPI = async (token) => {
  
  const response = await Axios({
    url: GET_BOROWWER_URL,
    method: 'GET',
    headers: {
      'api-key': getAPIKEY(),
      'Authorization': token
    },
  });
  return response.data;
};

const getActListAPI = async (token) => {
  
  const response = await Axios({
    url: GET_ACT_LIST_URL,
    method: 'GET',
    headers: {
      'api-key': getAPIKEY(),
      'Authorization': store?.getState()?.app?.authToken?.token || token
    },
  });
  return response.data;
};

const availCredit = async (customer_code) => {
  
  const response = await Axios({
    url: CREDIT_AVAIL_URL,
    method: 'POST',
    headers: {
      'api-key': getAPIKEY(),
      'Authorization': store.getState().app.authToken.token
    },
    data: {
      "customer_code" : customer_code
    }
  });
  return response.data;
};

const setOfferAPI = async (data) => {
  
  const response = await Axios({
    url: SET_OFFER_URL,
    method: 'POST',
    headers: {
      'api-key': getAPIKEY(),
      'Authorization': store.getState().app.authToken.token
    },
    data: {
        "offers":{
            "id": data.id,
            "status": "Accepted"
        }
    }
  });
  return response.data;
};

const getDocumentAPI = async () => {
  
  const response = await Axios({
    url: GET_DOCUMENT_URL,
    method: 'GET',
    headers: {
      'api-key': getAPIKEY(),
      'Authorization': store.getState().app.authToken.token
    }
  });
  return response.data;
};

const getEsignDocumentAPI = async () => {
  const response = await Axios({
    url: GET_ESIGN_DOCUMENT_URL,
    method: 'POST',
    headers: {
      'api-key': getAPIKEY(),
      'Authorization': store.getState().app.authToken.token
    }
  });
  return response.data;
};

const getIFSCRAzorPay = async (ifsc) => {
  
  const response = await Axios({
    url: GET_IFSC_URL+ifsc,
    method: 'GET',
  });
  return response.data;
};

const uploadDocumentAPI = async (data,documentId) => {
  
  const response = await Axios({
    url: UPLOAD_DOCUMENT_URL+"/"+documentId,
    method: 'PUT',
    headers: {
      'api-key': getAPIKEY(),
      'Authorization': store.getState().app.authToken.token
    },
    data: data
  });
  return response.data;
};

const callEsignInit = async (co_borrower_id) => {
  
  const response = await Axios({
    url: ESIGN_INIT_URL,
    method: 'POST',
    headers: {
      'api-key': getAPIKEY(),
      'Authorization': store.getState().app.authToken.token
    },
    data: {
        "co_borrower_id": co_borrower_id
        
    }
  });
  return response.data;
};

const checkEsignAPI = async () => {
  
  const response = await Axios({
    url: ESIGN_LIST_URL,
    method: 'GET',
    headers: {
      'api-key': getAPIKEY(),
      'Authorization': store.getState().app.authToken.token
    }
  });
  return response.data;
};

const getIFSCAcct = async (ifscCode,accountNumber) => {
  
  const response = await Axios({
    url: PENNY_DROP_URL,
    method: 'POST',
    headers: {
      'api-key': getAPIKEY(),
      'Authorization': store.getState().app.authToken.token
    },
    data: {
          "ifsc": ifscCode,
          "account_number": accountNumber
      }
  });
  return response.data;
};


const createBankAcccountAPI = async (data) => {
  
  const response = await Axios({
    url: CREATE_BANK_URL,
    method: 'POST',
    headers: {
      'api-key': getAPIKEY(),
      'Authorization': store.getState().app.authToken.token
    },
    data: data
  });
  return response.data;
};

const getBankListAPI = async (data) => {
  
  const response = await Axios({
    url: GET_BANK_URL,
    method: 'GET',
    headers: {
      'api-key': getAPIKEY(),
      'Authorization': store.getState().app.authToken.token
    }
  });
  return response.data;
};

const initEmandateAPI = async (data) => {
  
  const response = await Axios({
    url: GET_INIT_EMANDATE_URL,
    method: 'POST',
    headers: {
      'api-key': getAPIKEY(),
      'Authorization': store.getState().app.authToken.token
    }
  });
  return response.data;
};

const phyEmandateAPI = async (data) => {
  
  const response = await Axios({
    url: GET_EMANDATE_PHY_NACH_URL,
    method: 'POST',
    headers: {
      'api-key': getAPIKEY(),
      'Authorization': store.getState().app.authToken.token
    }
  });
  return response.data;
};

const setApiStepApi = async (key) => {
  
  const response = await Axios({
    url: GET_ACT_LIST_URL,
    method: 'POST',
    headers: {
      'api-key': getAPIKEY(),
      'Authorization': store.getState().app.authToken.token
    },
    data:key
  });
  return response.data;
};

const getPhoneList = async (pan) => {
  
  const response = await Axios({
    url: GET_PHONE_LIST_URL+"?pan_number="+pan,
    method: 'GET',
    headers: {
      'api-key': getAPIKEY()
    }
  });
  return response.data;
};

const esignEmailAPI = async (esign_id) => {
  
  const response = await Axios({
    url: GET_ESIGN_DATA_URL,
    method: 'POST',
    data: {
      payload: esign_id
    }
  });
  return response.data;
};


export { 
  getBorrowerAPI,
  callEsignInit,
  BORROWERSUPDATE,
  BORROWERS,
  getPAN,
  sendOTPAPI,
  authUserAPI,
  availCredit,
  setOfferAPI,
  getDocumentAPI,
  uploadDocumentAPI,
  getActListAPI,
  getIFSCRAzorPay,
  checkEsignAPI,
  getIFSCAcct,
  createBankAcccountAPI,
  getBankListAPI,
  initEmandateAPI,
  phyEmandateAPI,
  setApiStepApi,
  getEsignDocumentAPI,
  getPhoneList,
  esignEmailAPI,
  getPIN
};
